import React from 'react';
import Time from 'components/Time';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import Tooltip from 'components/Tooltip';
import api from 'api';
import autobind from 'autobind-decorator';
import Spinner from 'components/Spinner';
import { Link } from 'react-router-dom';
import { query } from 'redux-bees';
import copy from 'copy-to-clipboard';
import Pagination from 'components/Pagination';

const toRenderProp = ({ children, ...rest }) => children(rest);
const createQueryProvider = (...args) => query(...args)(toRenderProp);
const PaginationProvider = createQueryProvider('logs', api.getLogs, (perform, props) => {
  if (props.params.accountId !== null) {
    return perform({ page: props.params.page, accountId: props.params.accountId });
  }
  return perform({ page: props.params.page });
});

export default class LogEvents extends Component {
  static propTypes = {
    status: PropTypes.object.isRequired,
    logs: PropTypes.array,
  }

  state = { page: '1', accountId: null }

  @autobind
  handleFilterAccount(accountId) {
    this.setState({ accountId });
  }

  @autobind
  handlePageChange(page) {
    this.setState({ page });
  }

  formatMeta(meta) {
    return meta;
  }

  @autobind
  handleDataToClipboard(data) {
    copy(data);
  }

  @autobind
  renderLog(log) {
    return (
      <div key={log.id} className="Logs__item" >
        <div className="Logs__item__cell Logs__item__cell--created">
          <Tooltip label={`${log.id}`}>
            <Time value={log.attributes.createdAt} splitLine />
          </Tooltip>
        </div>
        <div className="Logs__item__cell Logs__item__cell--site">
          { log.attributes.siteId &&
            <Tooltip label={`${log.attributes.siteId}`}>
              <Link to={`/site/${log.attributes.siteId}`}>
                {log.attributes.siteName}
              </Link>
            </Tooltip>
          }
        </div>
        <div className="Logs__item__cell Logs__item__cell--account">
          { log.attributes.accountId &&
          <div>
            <Tooltip label={`${log.attributes.accountId} - ${log.attributes.accountEmail}`}>
              <button onClick={() => { this.handleDataToClipboard(log.attributes.accountEmail); }}>
                <i className="icon--info" />
              </button>
            </Tooltip>
            { ' ' }
            <button className="gray" onClick={() => { this.handleFilterAccount(log.attributes.accountId); }}>
              {log.attributes.accountName}
            </button>
          </div>
          }
        </div>
        <div className="Logs__item__cell Logs__item__cell--action">
          { log.attributes.ip &&
            <Tooltip label={log.attributes.ip}>
              {
                <a href={`https://tools.keycdn.com/geo?host=${log.attributes.ip}`} target="_blank" rel="noopener noreferrer">
                  { log.attributes.action }
                </a>
              }
            </Tooltip>
          }
          { !log.attributes.ip &&
            <span>
              {log.attributes.action}
            </span>
          }
        </div>
        <div className="Logs__item__cell Logs__item__cell--meta">
          { log.attributes.meta &&
            <Tooltip label={this.formatMeta(log.attributes.meta)}>
              <i
                role="button"
                className="icon--info"
                onClick={() => { this.handleDataToClipboard(log.attributes.meta); }}
                tabIndex={0}
              />
            </Tooltip>
          }
        </div>
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="Sites__spinner-container">
        <Spinner />
      </div>
    );
  }

  renderLogs(logs, status) {
    return (
      <div>
        <div className="Backend__title space--bottom-2">
          Logs
          {
            status.logs.isLoading &&
              this.renderLoading()
          }
        </div>
        <div className="Backups__list">
          { logs && logs.map(this.renderLog) }
        </div>
      </div>
    );
  }


  render() {
    return (
      <PaginationProvider params={this.state}>
        { ({ logs, status }) => (
          <div>
            { this.renderLogs(logs, status) }
            {
              logs &&
                <Pagination
                  data={status.logs.meta.pagination}
                  handlePageChange={this.handlePageChange}
                />
            }
          </div>
        )}
      </PaginationProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/LogEvents.jsx